import { stringify } from 'query-string';
import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'DRAFTS_GET',
  GET_SUCCESS: 'DRAFTS_GET_SUCCESS',
  GET_FAILURE: 'DRAFTS_GET_FAILURE',
  INVALIDATE_ITEM: 'DRAFTS_INVALIDATE_ITEM',
  GET_ALL: 'DRAFTS_GET_ALL',
  GET_ALL_SUCCESS: 'DRAFTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'DRAFTS_GET_ALL_FAILURE',
  POST: 'DRAFTS_POST',
  POST_SUCCESS: 'DRAFTS_POST_SUCCESS',
  POST_FAILURE: 'DRAFTS_POST_FAILURE',
  PATCH: 'DRAFTS_PATCH',
  PATCH_SUCCESS: 'DRAFTS_PATCH_SUCCESS',
  PATCH_FAILURE: 'DRAFTS_PATCH_FAILURE',
};

export const patch = actions.patch(draftId => `${BASE_V2_URL}/drafts/${draftId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});

export const get = actions.get(draftId => `${BASE_V2_URL}/drafts/${draftId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const getAll = actions.getAll(
  query => `${BASE_V2_URL}/drafts/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post((id, value) => `${BASE_V2_URL}/drafts/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
